import { TFunction } from 'react-i18next';
import { Path, UseFormGetValues } from 'react-hook-form';
import { CheckboxGroupFieldValidationOptions } from '../index';

export function applyCheckboxGroupValidationOptions<TFieldValues>(
  name: Path<TFieldValues>,
  getValues: UseFormGetValues<TFieldValues>,
  t: TFunction,
  rules: CheckboxGroupFieldValidationOptions<TFieldValues> = {},
) {
  // If this rule selected check that you will trigger validation in child components
  // in case of changing for this rule
  if (rules.atLeastOne) {
    rules.validate = {
      hasAtLeastOneSelectedCheckbox() {
        const checkboxInputs =
          (getValues(name) as { [key: string]: unknown }) || {};
        const selectedOptions = Object.values(checkboxInputs).filter(
          (value) => value === 'true' || value === true,
        );

        return (
          selectedOptions.length > 0 ||
          t('site.pricing.validation.error.code.AT_LEAST_ONE_OPTION')
        );
      },

      ...rules.validate,
    };
  }

  return rules;
}
